var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as IntegrationService from '../service/integration-service.js';
import { ResourceProperty } from './ResourceProperty.js';
import { Bkper } from './Bkper.js';
/**
 * This class defines a Integration from an [[User]] to an external service.
 *
 * @public
 */
export class Integration extends ResourceProperty {
    constructor(payload, config) {
        super(payload || {});
        this.config = config;
    }
    /** @internal */
    getConfig() {
        return this.config || Bkper.globalConfig;
    }
    /**
     * Gets the [[Book]] id of the Integration.
     *
     * @returns The Integration's Book id
     */
    getBookId() {
        return this.payload.bookId;
    }
    /**
     * Gets the id of the Integration.
     *
     * @returns This Integration's id
     */
    getId() {
        return this.payload.id;
    }
    /**
     * Gets the name of the Integration.
     *
     * @returns The Integration's name
     */
    getName() {
        return this.payload.name;
    }
    /**
     * Sets the name of the Integration.
     *
     * @param name - The name of the Integration
     *
     * @returns The Integration, for chaining
     */
    setName(name) {
        this.payload.name = name;
        return this;
    }
    /**
     * Gets the name of the user who added the Integration.
     *
     * @returns The user name of who added the Integration
     */
    getAddedBy() {
        return this.payload.addedBy;
    }
    /**
     * Gets the agent id of the Integration.
     *
     * @returns The Integration's agent id
     */
    getAgentId() {
        return this.payload.agentId;
    }
    /**
     * Gets the logo of the Integration.
     *
     * @returns The Integration's logo
     *
     * @deprecated Use getLogoUrl instead.
     */
    getLogo() {
        return this.payload.logo;
    }
    /**
     * Gets the logo url of this Integration.
     *
     * @returns The logo url of this Integration
     */
    getLogoUrl() {
        return this.payload.logo;
    }
    /**
     * Gets the logo url of this Integration in dark mode.
     *
     * @returns The logo url of this Integration in dark mode
     */
    getLogoUrlDark() {
        return this.payload.logoDark;
    }
    /**
     * Gets the date when the Integration was added.
     *
     * @returns The Integration add date in milliseconds
     */
    getDateAddedMs() {
        return this.payload.dateAddedMs;
    }
    /**
     * Gets the date when the Integration was last updated.
     *
     * @returns The Integration last update date in milliseconds
     */
    getLastUpdateMs() {
        return this.payload.lastUpdateMs;
    }
    /**
     * Performs update Integration.
     *
     * @returns The updated Integration object
     */
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            const bookId = this.getBookId();
            if (bookId) {
                this.payload = yield IntegrationService.updateIntegration(bookId, this.payload, this.getConfig());
            }
            return this;
        });
    }
    /**
     * Performs remove Integration.
     *
     * @returns The removed Integration object
     */
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            const bookId = this.getBookId();
            const integrationId = this.getId();
            if (bookId && integrationId) {
                this.payload = yield IntegrationService.deleteIntegration(bookId, integrationId, this.getConfig());
            }
            return this;
        });
    }
}
//# sourceMappingURL=Integration.js.map